import React, { useState } from "react"

import classNames from "gpages/utils/classnames"
import { useNavScrollHide } from "gpages/hooks/common"
import { scrollToTarget } from "gpages/utils/common"

import * as styles from "./nav.module.scss"
import logoImg from "@images/nav-logo.png"
import menuImg from "@images/nav-menu.png"
import fixedBuyImg from "@images/fixed-buy.png"
import fixedJointBuyImg from "@images/fixed-buy-ggg.png"
import config from "@config"
import Clickable from "gpages/components/clickable"
import { useAppContext } from "@src/context/appContext"

const items = [
  { name: "票务信息", key: "ticket_info" },
  { name: "活动介绍", key: "intro" },
  { name: "会场地图", key: "map" },
  { name: "游戏玩法", key: "play" },
  ...(config.data.showStageActivities
    ? [{ name: "舞台活动", key: "stage" }]
    : []),
  { name: "参展厂商", key: "exhibitor" },
  { name: "参展游戏", key: "games" },
  { name: "嘉宾阵容", key: "guests" },
  { name: "合作伙伴", key: "partners" },
  { name: "合作媒体", key: "media" },
  { name: "机核品牌", key: "brands" },
  { name: "立刻购票", url: config.data.ticketUrl },
]

const NavItems = ({ onItemClick }) =>
  items.map((item) => (
    <Clickable
      key={item.name}
      appNavTo={item.url}
      href={item.key ? `#${item.key}` : undefined}
      onClick={(event) => {
        onItemClick?.()
        const scrolled = scrollToTarget(event.currentTarget)
        if (scrolled) {
          event.preventDefault()
        }
      }}
    >
      {item.name}
    </Clickable>
  ))

const Nav = () => {
  const [open, setOpen] = useState(false)
  const visible = useNavScrollHide(1000, [false, true])
  const { isAppLayout } = useAppContext()

  return (
    <>
      <div
        className={classNames(styles.mask, { [styles.visible]: open })}
        onClick={() => setOpen(false)}
      />
      <nav
        className={classNames(styles.nav, {
          [styles.visible]: visible || open,
          [styles.mobile]: isAppLayout,
          [styles.open]: open,
        })}
      >
        <img src={logoImg} alt="GCORES" className={styles.logo} />
        {isAppLayout ? (
          <>
            <Clickable
              className={styles.menuButton}
              onClick={() => setOpen((value) => !value)}
            >
              <img src={menuImg} alt="menu" />
            </Clickable>
            <div className={styles.mobileList}>
              <NavItems onItemClick={() => setOpen(false)} />
            </div>
          </>
        ) : (
          <div className={styles.right}>
            <NavItems />
          </div>
        )}
      </nav>
      <div
        className={classNames(styles.buyButtons, {
          [styles.visible]: visible || open,
        })}
      >
        <Clickable
          className={styles.buyButton}
          appNavTo={config.data.ticketUrl}
        >
          <img src={fixedBuyImg} alt="立刻购票" />
        </Clickable>
        <Clickable
          className={styles.buyButton}
          appNavTo={config.data.jointTicketUrl}
        >
          <img src={fixedJointBuyImg} alt="购买 GGG 联票" />
        </Clickable>
      </div>
    </>
  )
}

export default Nav
